import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class ChangeEmailModal extends Modal {

  oninit(vnode) {
    super.oninit(vnode);
    this.email = Stream(app.session.user.email());
    this.password = Stream('');
  }

  className() {
    return 'ChangeEmailModal Modal--small';
  }

  title() {
    return app.translator.trans('core.forum.change_email.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <input
              type="text"
              name="email"
              className="FormControl"
              placeholder={app.session.user.email()}
              bidi={this.email}
              disabled={this.submitLoading}
            />
          </div>
          <div className="Form-group">
            <input
              type="password"
              name="password"
              className="FormControl"
              placeholder={app.translator.trans('lltq-reset-password.forum.modals.confirm_password_placeholder')}
              bidi={this.password}
              disabled={this.submitLoading}
            />
          </div>
          <div className="Form-group">
            {Button.component(
              {
                className: 'Button Button--primary Button--block',
                type: 'submit',
                loading: this.submitLoading,
              },
              app.translator.trans('lltq-reset-password.forum.modals.submit_button')
            )}
          </div>
        </div>
      </div>
    );
  }

  getAttributes = () => {
    return {
      email: this.email()
    };
  }

  onsubmit(e) {
    e.preventDefault();

    if (this.email() === app.session.user?.email()) {
      this.hide();
      return;
    }

    this.submitLoading = true;

    app.session.user
      .save(
        this.getAttributes(), { 
          method: "post",
          url: '/api/edit-user',
          meta: { password: this.password() },
          errorHandler: this.onerror.bind(this)
      })
      .then((request) => {
        this.submitLoading = false;
        this.hide();
      })
      .catch(() => {})
      .then(this.loaded.bind(this));
  }

  onerror(error) {
    if (error.status === 401) {
      error.alert.content = app.translator.trans('core.forum.change_email.incorrect_password_message');
      this.submitLoading = false;
    }

    if (error.response?.errors && error.response?.errors[0]?.code == 'access_forbidden') {
      error.alert.content = app.translator.trans('lltq-reset-password.forum.modals.forbidden_message');
      this.submitLoading = false; 
    }

    super.onerror(error);
  }
}
